<template>
    <div class="finally_content">
        <div class="finallytoos">
            <div class="finallytoos_top">
                <div></div>
                <p>合作伙伴</p>
            </div>
            <div class="midtext" style="width:281px;white-space: nowrap;">COOPERATIVE PARTNER</div>
            <div class="showLisecv">
                <div><img src="./../../images/cooperation/hzfp7.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp8.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp9.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp16.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp17.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp37.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp23.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp32.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp31.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp34.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp27.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp35.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp42.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp38.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp5.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp6.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp1.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp2.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp3.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp10.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp21.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp19.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp20.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp30.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp14.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp41.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp40.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp50.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp22.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp11.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp28.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp29.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp24.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp4.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp18.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp44.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp33.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp25.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp26.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp13.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp12.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp36.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp15.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp45.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp46.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp47.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp48.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hzfp49.png" alt="版权家-合作伙伴" /></div>
                <div><img src="./../../images/cooperation/hlast.png" alt="版权家-合作伙伴"/></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firfinally',
        data(){
            return {
                
            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
    .finally_content{
        min-height:533px;
        background:rgba(250,252,254,1);
        .finallytoos{
            width: 1334px;
            min-height: 533px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            .midtext{
                margin-top:50px;
                width:213px;
                height:28px;
                font-size:20px;
                font-weight:400;
                color:rgba(4,4,4,1);
                line-height:28px;
                letter-spacing:2px;
                margin-bottom:50px;
                margin-left: -30px;
            }
            .finallytoos_top{
                padding-top:80px;
                height:55px;
                line-height:55px;
                display:flex;
                margin-bottom:14px;
                p{
                    height:42px;
                    font-size:30px;
                    font-weight:800;
                    color:rgba(4,4,4,1);
                    letter-spacing:3px;
                    margin-left: -93px;
                }
                div{
                    width:55px;
                    height:55px;
                    background:rgba(255,216,0,1);
                    border-radius:50%;
                }
            }
            .showLisecv{
                /*display:flex;*/
                /*justify-content: flex-start;*/
                /*flex-wrap: wrap;*/
                width: 100%;
                overflow: hidden;
                white-space: normal;
                div{
                    display: inline-block;
                    width:248px;
                    height:103px;
                    /*background:rgba(255,255,255,1);*/
                    /*box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);*/
                    margin-right:18px;
                    margin-bottom:20px;
                    line-height:103px;
                    text-align:center;
                    vertical-align: middle;
                    img{
                        vertical-align: middle;
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    &:hover{
                        box-shadow:0 8px 40px 0 rgba(29,31,108,0.08);
                    }
                }
            }
        }
    }
</style>